import { FC } from 'react'
import { getStyledAboutTitle } from '../../styled-components/AboutSection.styled'

export interface AboutTitleContentProps {

}

export const AboutTitleContent: FC<AboutTitleContentProps> = (props) => {

    const StyledTitleSection = getStyledAboutTitle()

    return (
        <StyledTitleSection>
            <div>
                <div className='about-title'>About Us</div>
                <div className='about-description'>At Besnik Consultancy, we take pride in our values - service, integrity and excellence</div>
            </div>
            <div className='about-button'>Learn more</div>
        </StyledTitleSection>
    )
}